module.exports = __webpack_public_path__ + "static/media/4.d655f160.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/remoteSmartLinkIOT/img/4.png
// module id = 467
// module chunks = 0